import {types} from '../../types';

const setGetHistoryListAction = (payload) => {
    return {
        type: types.report.SET_HISTORY_LIST_MOBILE,
        payload,
      }
}

const setGetCashiersProfileAction = (payload) => {
  return {
    type: types.report.SET_CASHIERS_PROFILE_MOBILE,
    payload
  }
}

const setGetJackpotHistoryListAction = (payload) => {
  return {
      type: types.report.SET_HISTORY_JACKPOT_MOBILE,
      payload,
    }
}

const setGetBonusHistoryListAction = (payload) => {
  return {
      type: types.report.SET_HISTORY_BONUSES_MOBILE,
      payload,
    }
}


const setGetGgrAction = (payload) => {
  return {
      type: types.report.SET_GGR_MOBILE,
      payload,
    }
}

const setGetOperationsReplenishmentAction = (payload) => {
return {
    type: types.report.SET_OPERATION_REPLENISHMENT_MOBILE,
    payload,
  }
}

const setGetOperationsWithdrawalAction = (payload) => {
return {
    type: types.report.SET_OPERATION_WITHDRAWAL_MOBILE,
    payload,
  }
}

export {
  setGetHistoryListAction as SetGetHistoryListAction,
  setGetCashiersProfileAction  as SetGetCashiersProfileAction,
  setGetJackpotHistoryListAction  as SetGetJackpotHistoryListAction,
  setGetBonusHistoryListAction  as SetGetBonusHistoryListAction,
  setGetOperationsWithdrawalAction  as SetGetOperationsWithdrawalAction,
  setGetOperationsReplenishmentAction  as SetGetOperationsReplenishmentAction,
  setGetGgrAction as SetGetGgrAction
}